
export interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

export const faqCategories = [
  { id: 'all', label: 'Todas', icon: 'ri-apps-line', count: 30 },
  { id: 'reservas', label: 'Reservas', icon: 'ri-calendar-check-line', count: 7 },
  { id: 'checkin', label: 'Check-in & Check-out', icon: 'ri-key-2-line', count: 5 },
  { id: 'apartamentos', label: 'Apartamentos', icon: 'ri-home-4-line', count: 6 },
  { id: 'localizacao', label: 'Localização', icon: 'ri-map-pin-2-line', count: 4 },
  { id: 'experiencias', label: 'Experiências', icon: 'ri-compass-3-line', count: 4 },
  { id: 'pagamentos', label: 'Pagamentos', icon: 'ri-secure-payment-line', count: 4 },
];

export const faqItems: FAQItem[] = [
  // RESERVAS
  {
    id: 1,
    category: 'reservas',
    question: 'Como posso fazer uma reserva?',
    answer: 'Pode reservar diretamente através do nosso site, selecionando o apartamento desejado e as datas pretendidas. Também pode contactar-nos via WhatsApp (+351 962 050 526) ou email (info@seaviewlevada.pt) para reservas personalizadas ou de última hora.',
  },
  {
    id: 2,
    category: 'reservas',
    question: 'É possível fazer reservas de última hora?',
    answer: 'Sim! Para reservas de última hora, recomendamos que entre em contacto diretamente via WhatsApp para verificar disponibilidade imediata. Respondemos em minutos durante o horário de atendimento (08h–22h).',
  },
  {
    id: 3,
    category: 'reservas',
    question: 'Qual é a estadia mínima?',
    answer: 'A estadia mínima é de 2 noites. Em épocas altas (julho, agosto e festividades) pode ser exigida uma estadia mínima de 3 a 5 noites. Consulte a disponibilidade para as suas datas específicas.',
  },
  {
    id: 4,
    category: 'reservas',
    question: 'Qual é a política de cancelamento?',
    answer: 'Oferecemos cancelamento gratuito até 7 dias antes da data de chegada. Cancelamentos entre 3 e 7 dias antes implicam retenção de 50% do valor total. Cancelamentos com menos de 3 dias de antecedência não são reembolsáveis. Em casos de força maior, analisamos cada situação individualmente.',
  },
  {
    id: 5,
    category: 'reservas',
    question: 'Posso alterar as datas da minha reserva?',
    answer: 'Sim, pode alterar as datas da sua reserva sujeito a disponibilidade e sem custos adicionais se a alteração for feita com mais de 7 dias de antecedência. Para alterações de última hora, entre em contacto connosco via WhatsApp.',
  },
  {
    id: 6,
    category: 'reservas',
    question: 'Recebo confirmação da reserva?',
    answer: 'Sim, após a confirmação do pagamento receberá um email com todos os detalhes da reserva, incluindo morada completa, instruções de check-in, código de acesso e contactos de emergência.',
  },
  {
    id: 7,
    category: 'reservas',
    question: 'Posso reservar para grupos grandes?',
    answer: 'Sim! Temos 4 apartamentos disponíveis que podem ser reservados em conjunto para grupos. O Apartamento 4 (T2 Premium) acomoda até 4 pessoas. Para grupos, contacte-nos diretamente para obter condições especiais.',
  },

  // CHECK-IN & CHECK-OUT
  {
    id: 8,
    category: 'checkin',
    question: 'Qual é o horário de check-in e check-out?',
    answer: 'O check-in é a partir das 15h00 e o check-out até às 11h00. Horários flexíveis podem ser acordados mediante disponibilidade — basta contactar-nos com antecedência via WhatsApp.',
  },
  {
    id: 9,
    category: 'checkin',
    question: 'Como funciona o check-in? Há receção?',
    answer: 'O check-in é feito de forma autónoma através de uma caixa de chaves segura (key box) com código personalizado. Após a confirmação da reserva, enviamos todas as instruções detalhadas por email e WhatsApp. Estamos sempre disponíveis por telefone para qualquer dúvida.',
  },
  {
    id: 10,
    category: 'checkin',
    question: 'Posso fazer check-in tardio (após as 22h)?',
    answer: 'Sim! O sistema de key box permite check-in a qualquer hora do dia ou da noite, sem necessidade de receção presencial. Basta seguir as instruções enviadas por email. Para chegadas muito tardias, recomendamos avisar-nos com antecedência.',
  },
  {
    id: 11,
    category: 'checkin',
    question: 'É possível guardar bagagem antes do check-in ou após o check-out?',
    answer: 'Sim, disponibilizamos armazenamento de bagagem gratuito antes do check-in e após o check-out, sujeito a disponibilidade. Contacte-nos com antecedência para confirmar.',
  },
  {
    id: 12,
    category: 'checkin',
    question: 'O que devo fazer no check-out?',
    answer: 'No check-out, pedimos que deixe as chaves na key box, feche todas as janelas e portas, e coloque o lixo nos contentores indicados. Não é necessária limpeza — a nossa equipa trata de tudo. Agradecemos que nos deixe uma avaliação!',
  },

  // APARTAMENTOS
  {
    id: 13,
    category: 'apartamentos',
    question: 'O que está incluído nos apartamentos?',
    answer: 'Todos os apartamentos incluem: roupa de cama e toalhas, Wi-Fi de alta velocidade, ar condicionado, cozinha totalmente equipada (frigorífico, micro-ondas, fogão, utensílios), TV, produtos de higiene básicos e kit de boas-vindas com produtos locais da Madeira.',
  },
  {
    id: 14,
    category: 'apartamentos',
    question: 'Os apartamentos têm vista para o mar?',
    answer: 'Sim! Todos os nossos apartamentos têm vista para o mar ou para a montanha. O nome "Seaview & Levada Escape" reflete exatamente isso — pode acordar com a vista da baía de Machico e das montanhas verdejantes da Madeira.',
  },
  {
    id: 15,
    category: 'apartamentos',
    question: 'Há estacionamento disponível?',
    answer: 'Sim, disponibilizamos estacionamento gratuito para todos os hóspedes junto ao alojamento. O espaço é suficiente para viaturas de tamanho normal. Para viaturas de grande porte ou autocaravanas, contacte-nos previamente.',
  },
  {
    id: 16,
    category: 'apartamentos',
    question: 'Os animais de estimação são permitidos?',
    answer: 'Aceitamos animais de estimação de pequeno porte (até 10kg) mediante pedido prévio e sujeito a disponibilidade. Pode ser aplicada uma taxa de limpeza adicional. Contacte-nos antes de reservar para confirmar.',
  },
  {
    id: 17,
    category: 'apartamentos',
    question: 'Existe Wi-Fi nos apartamentos?',
    answer: 'Sim, todos os apartamentos têm Wi-Fi de alta velocidade (fibra ótica) incluído sem custo adicional. A velocidade é suficiente para trabalho remoto, streaming e videochamadas.',
  },
  {
    id: 18,
    category: 'apartamentos',
    question: 'Os apartamentos têm ar condicionado?',
    answer: 'Sim, todos os apartamentos estão equipados com ar condicionado reversível (aquecimento e arrefecimento). O clima da Madeira é ameno durante todo o ano, mas o ar condicionado garante o máximo conforto em qualquer estação.',
  },

  // LOCALIZAÇÃO
  {
    id: 19,
    category: 'localizacao',
    question: 'Onde ficam os apartamentos exatamente?',
    answer: 'Os apartamentos ficam em Machico, Madeira, junto à Levada do Caniçal. Estamos a 5 minutos a pé do centro histórico de Machico, a 15 minutos do Aeroporto Internacional da Madeira e a 30 minutos do Funchal.',
  },
  {
    id: 20,
    category: 'localizacao',
    question: 'Como chegar do aeroporto ao alojamento?',
    answer: 'O Aeroporto Internacional da Madeira fica a apenas 15 minutos de carro. Pode alugar um carro no aeroporto (recomendado para explorar a ilha), apanhar um táxi (cerca de €15–20) ou usar o serviço de transfer que podemos organizar mediante pedido prévio.',
  },
  {
    id: 21,
    category: 'localizacao',
    question: 'Há supermercados e restaurantes perto?',
    answer: 'Sim! A menos de 5 minutos a pé encontra supermercados, padarias, farmácias e vários restaurantes com especialidades madeirenses. O mercado municipal de Machico fica a 10 minutos a pé e é uma experiência imperdível.',
  },
  {
    id: 22,
    category: 'localizacao',
    question: 'É necessário carro para se deslocar na Madeira?',
    answer: 'Recomendamos vivamente alugar um carro para explorar a ilha ao máximo. Machico tem bons acessos de autocarro para o Funchal, mas para visitar levadas, praias remotas e miradouros, o carro é essencial. Podemos recomendar empresas de aluguer de confiança.',
  },

  // EXPERIÊNCIAS
  {
    id: 23,
    category: 'experiencias',
    question: 'Podem recomendar atividades na Madeira?',
    answer: 'Claro! Temos uma página dedicada às Experiências na Madeira com as nossas recomendações pessoais: passeios de mota 4, levadas e trilhos, observação de golfinhos, praias e piscinas naturais, e os melhores restaurantes de Machico. Consulte a secção "Experiências" no nosso site.',
  },
  {
    id: 24,
    category: 'experiencias',
    question: 'A Levada do Caniçal fica mesmo ao lado?',
    answer: 'Sim! A entrada da Levada do Caniçal fica a menos de 2 minutos a pé dos apartamentos — é literalmente ao virar da esquina. É uma das levadas mais bonitas da Madeira, com vistas deslumbrantes sobre o oceano e a baía de Machico.',
  },
  {
    id: 25,
    category: 'experiencias',
    question: 'Podem ajudar a organizar atividades e passeios?',
    answer: 'Sim! Temos parcerias com operadores locais de confiança para passeios de mota 4, observação de golfinhos, mergulho, canyoning e muito mais. Contacte-nos antes ou durante a sua estadia e tratamos de tudo por si.',
  },
  {
    id: 26,
    category: 'experiencias',
    question: 'Qual é a melhor época para visitar a Madeira?',
    answer: 'A Madeira é um destino de eleição durante todo o ano graças ao seu clima ameno. A primavera (março–maio) é ideal para levadas e flores. O verão (junho–setembro) é perfeito para praias e mar. O outono e inverno têm menos turistas e preços mais acessíveis, com paisagens igualmente deslumbrantes.',
  },

  // PAGAMENTOS
  {
    id: 27,
    category: 'pagamentos',
    question: 'Quais são os métodos de pagamento aceites?',
    answer: 'Aceitamos pagamento por transferência bancária (MB Way, IBAN), cartão de crédito/débito e PayPal. Para reservas diretas via WhatsApp, o pagamento é feito por MB Way ou transferência bancária. Não aceitamos pagamento em dinheiro.',
  },
  {
    id: 28,
    category: 'pagamentos',
    question: 'Quando é feito o pagamento?',
    answer: 'Para reservas com mais de 30 dias de antecedência, pedimos 30% de sinal no momento da reserva e o restante 70% até 7 dias antes da chegada. Para reservas de última hora (menos de 7 dias), o pagamento total é exigido no momento da reserva.',
  },
  {
    id: 29,
    category: 'pagamentos',
    question: 'É cobrada taxa turística?',
    answer: 'Sim, a Região Autónoma da Madeira cobra uma taxa turística de €2 por pessoa por noite, com um máximo de 7 noites (€14 por pessoa). Esta taxa é paga diretamente no check-in e não está incluída no preço da reserva.',
  },
  {
    id: 30,
    category: 'pagamentos',
    question: 'Os preços incluem todas as despesas?',
    answer: 'Sim, os preços incluem limpeza final, roupa de cama e toalhas, Wi-Fi, estacionamento e kit de boas-vindas. Não há taxas escondidas. A única despesa adicional é a taxa turística obrigatória (€2/pessoa/noite, máx. 7 noites).',
  },
];
